<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-secondary" (click)="refresh()">
                                <fa-icon class="d-none d-sm-inline-block" [icon]="faRotate"></fa-icon> Refresh
                            </button>
                            <button type="button" class="btn btn-sm btn-primary" (click)="openSelectedDetails()" [disabled]="!grid.hasItemSelected">
                                <fa-icon class="d-none d-sm-inline-block" [icon]="faEye"></fa-icon> View Details
                            </button>
                        </div>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Vista Uploads'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        (dblclick)="openSelectedDetails()"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Created On'" [binding]="'createdOnDate'" [width]="160" [format]="'MM/dd/yyyy hh:mm tt'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'File Type'" [binding]="'recordType'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Started By'" [binding]="'createdByName'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'In Progress'" [binding]="'inProgress'" [width]="90" [align]="'center'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Rows'" [binding]="'rowCount'" [width]="80" [align]="'center'" [format]="'d'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Batch #'" [binding]="'batchId'" [width]="100" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Staged On'" [binding]="'stagedOnDate'" [width]="160" [format]="'MM/dd/yyyy hh:mm tt'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Completed On'" [binding]="'completedOnDate'" [width]="160" [format]="'MM/dd/yyyy hh:mm tt'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Failure Summary'" [binding]="'failureSummary'" [width]="'2*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'File Name'" [binding]="'fileName'" [width]="'2*'" [isReadOnly]="true"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
